import React from 'react';

const HeadingPrivacy = () => {
  return (
    <section className="bg-[#F37920] text-white py-12 sm:py-16 md:py-20 lg:py-4">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <h2 className="text-xl sm:text-2xl md:text-3xl font-semibold mb-4 sm:mb-6">
          Terms
        </h2>
        <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold">
          Privacy Policy
        </h1>
      </div>
    </section>
  );
}

export default HeadingPrivacy;
